import React from 'react';
import { translate } from 'react-i18next';
import IdleTimer from 'react-idle-timer';

import './app.scss';

import observeRootStore from '../../components/hoc/observeRootStore';
import LocalizedComponent from '../../components/localizedComponent';
import Header from '../../components/header';
import Drawer from '../../components/drawer';
import Filter from '../../components/filter';
import MapContainer from '../../components/mapContainer';
import Screensaver from '../../components/screensaver';
import * as constants from '../../appConstants';
import screensaverConfig from '../../screensaverConfig.js';
import videoBackground from '../../assets/media/wave-bkg_v18.mp4'

export class App extends LocalizedComponent {
    constructor(props) {
        super(props);
        this.idleTimer = null;

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
                this.serviceWorker = registration;
            });
        }
    }

    // Listen for actions on the document to set screensaver to inactive
    onAction = e => {
        this.props.rootStore.uiStore.screensaverActive = false;
    };

    // On idle set screensaver to active and reset app
    onIdle = e => {
        this.props.rootStore.uiStore.screensaverActive = true;
        this.props.rootStore.uiStore.activeMap = constants.NORTH_AMERICA;
        this.props.rootStore.uiStore.selectedFilter = constants.FILTER_ALL;
        this.props.rootStore.uiStore.selectedState = null;

        if (this.serviceWorker) {
            // if a service worker has been registered, check for updates
            this.serviceWorker.update();
        }
    };

    render() {
        const { rootStore } = this.props;
        const onLandingView =
            rootStore.uiStore.activeMap === constants.NORTH_AMERICA;
        return (
            <div
                className={
                    'App ' +
                    (rootStore.uiStore.isDrawerOpen ? 'drawer-is-open' : '')
                }
            >
                {rootStore.uiStore.screensaverActive && <Screensaver />}
                {onLandingView && <Header />}
                <MapContainer />
                {!onLandingView && <Filter />}
                <video className='videoBg'
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    preload="true">
                    <source src={videoBackground} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <Drawer />
                <IdleTimer
                    ref={ref => {
                        this.idleTimer = ref;
                    }}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    timeout={screensaverConfig.idleDelay}
                    events={screensaverConfig.events}
                />
            </div>
        );
    }
}

export default translate()(observeRootStore(App));
